/* eslint-disable no-unused-vars */
export enum BenefitsActionType {
  GET_BENEFITS = 'get_benefits',
  GET_BENEFITS_SUCCESS = 'get_benefits_success',
  GET_BENEFITS_FAILURE = 'get_benefits_failure',

  GET_CART_SESSION = 'get_cart_session',
  GET_CART_SESSION_SUCCESS = 'get_cart_session_success',
  GET_CART_SESSION_FAILURE = 'get_cart_session_failure',

  UPDATE_CART_SESSION = 'update_cart_session',
  UPDATE_CART_SESSION_SUCCESS = 'update_cart_session_success',
  UPDATE_CART_SESSION_FAILURE = 'update_cart_session_failure',

  ADD_BENEFIT_TO_CART = 'add_to_cart',
  REMOVE_BENEFIT_FROM_CART = 'remove_from_cart',
  CLEAR_BENEFITS_FROM_CART = 'clear_benefits_cart',

  SET_ENROLLMENT_TYPE = 'set_enrollment_type',
  SET_QLE_FILES = 'set_qle_files',
}
